import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Youtube, ChevronRight, Heart } from 'lucide-react';

const Footer: React.FC = () => {
    const currentYear = new Date().getFullYear();

    // ← QUICK LINKS AVEC ACTUALITÉS AJOUTÉES
    const quickLinks = [
        { label: 'Mot du Président', href: '/#president-message' },
        { label: 'Notre Vision', href: '/#vision' },
   //     { label: 'Actualités', to: '/actualites' }, // ← NOUVEAU LIEN ACTUALITÉS
        { label: 'Nos fédérations', to: '/federations' },
        { label: 'Adhésion', href: '/#adhesion' }
    ];

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const legalLinks = [
        { label: 'Mentions Légales', href: '#legal' },
        { label: 'Politique de Confidentialité', href: '#privacy' },
        { label: 'Conditions d\'Utilisation', href: '#terms' },
        { label: 'Statuts du Parti', href: '#statuts' },
        { label: 'Contact', href: '#contact' }
    ];

    const socialLinks = [
        {
            icon: <Facebook className="w-5 h-5" />,
            href: '#facebook',
            label: 'Facebook',
            color: 'hover:bg-blue-600'
        },
        {
            icon: <Twitter className="w-5 h-5" />,
            href: '#twitter',
            label: 'Twitter',
            color: 'hover:bg-blue-400'
        },
        {
            icon: <Instagram className="w-5 h-5" />,
            href: '#instagram',
            label: 'Instagram',
            color: 'hover:bg-pink-600'
        },
        {
            icon: <Youtube className="w-5 h-5" />,
            href: '#youtube',
            label: 'YouTube',
            color: 'hover:bg-red-600'
        }
    ];

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const provinces = [
        'Estuaire', 'Haut-Ogooué', 'Moyen-Ogooué', 'Ngounié',
        'Nyanga', 'Ogooué-Ivindo', 'Ogooué-Lolo', 'Ogooué-Maritime', 'Woleu-Ntem'
    ];

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const handleNewsletterSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        // Logic pour newsletter
    };

    return (
        <footer className="bg-gray-900 text-white">
            {/* Main Footer Content */}
            <div className="py-16">
                <div className="container mx-auto px-4">
                    <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-8">

                        {/* About Section avec logo UDB - vraies couleurs */}
                        <div className="lg:col-span-2 md:col-span-1">
                            <div className="flex items-center space-x-3 mb-6">
                                {/* Logo UDB avec vraies couleurs */}
                                <div className="w-16 h-16 relative">
                                    <img
                                        src="/logo128.png"
                                        alt="UDB Logo"
                                        className="w-16 h-16 object-contain"
                                        onError={(e) => {
                                            // Fallback avec vraies couleurs UDB
                                            e.currentTarget.style.display = 'none';
                                            if (e.currentTarget.parentElement) {
                                                const fallback = document.createElement('div');
                                                fallback.className = 'w-16 h-16 rounded-full bg-gradient-to-br from-primary-blue to-primary-green border-3 border-primary-yellow flex items-center justify-center relative overflow-hidden shadow-lg';
                                                fallback.style.backgroundColor = '#00469b';
                                                fallback.style.borderColor = '#ffd400';

                                                const topDiv = document.createElement('div');
                                                topDiv.className = 'absolute top-0 left-0 right-0 h-8';
                                                topDiv.style.backgroundColor = '#009026';

                                                const bottomDiv = document.createElement('div');
                                                bottomDiv.className = 'absolute bottom-0 left-0 right-0 h-8';
                                                bottomDiv.style.backgroundColor = '#00469b';

                                                const textSpan = document.createElement('span');
                                                textSpan.className = 'text-primary-yellow font-bold text-sm relative z-10';
                                                textSpan.style.color = '#ffd400';
                                                textSpan.textContent = 'UDB';

                                                fallback.appendChild(topDiv);
                                                fallback.appendChild(bottomDiv);
                                                fallback.appendChild(textSpan);
                                                e.currentTarget.parentElement.appendChild(fallback);
                                            }
                                        }}
                                    />
                                </div>
                                <div>
                                    <h3 className="text-xl font-bold">Union Démocratique des Bâtisseurs</h3>
                                    <p className="text-sm text-gray-400">Inclusivité • Développement • Félicité</p>
                                </div>
                            </div>

                            <p className="text-gray-400 leading-relaxed mb-6">
                                Un mouvement politique engagé pour la transformation positive du Gabon,
                                la promotion de la démocratie et le développement durable de notre nation.
                            </p>

                            {/* Social Media */}
                            <div className="space-y-4">
                                <h4 className="font-semibold text-lg">Suivez-nous</h4>
                                <div className="flex space-x-3">
                                    {socialLinks.map((social, index) => (
                                        <a
                                            key={index}
                                            href={social.href}
                                            className={`w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center transition-all ${social.color} hover:scale-110`}
                                            aria-label={social.label}
                                        >
                                            {social.icon}
                                        </a>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Quick Links - Navigation à droite AVEC ACTUALITÉS */}
                        <div className="lg:col-span-1 md:col-span-1 lg:text-right">
                            <h4 className="font-semibold text-lg mb-6">Navigation</h4>
                            <ul className="space-y-3">
                                {quickLinks.map((link, index) => (
                                    <li key={index} className="lg:flex lg:justify-end">
                                        {link.to ? (
                                            <Link
                                                to={link.to}
                                                className="text-gray-400 hover:text-white transition-colors flex items-center space-x-2 group lg:flex-row-reverse lg:space-x-reverse"
                                            >
                                                <ChevronRight className="w-4 h-4 group-hover:translate-x-1 transition-transform lg:group-hover:-translate-x-1 lg:rotate-180" />
                                                <span>{link.label}</span>
                                            </Link>
                                        ) : (
                                            <Link
                                                to={link.href!}
                                                className="text-gray-400 hover:text-white transition-colors flex items-center space-x-2 group lg:flex-row-reverse lg:space-x-reverse"
                                            >
                                                <ChevronRight className="w-4 h-4 group-hover:translate-x-1 transition-transform lg:group-hover:-translate-x-1 lg:rotate-180" />
                                                <span>{link.label}</span>
                                            </Link>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom Bar */}
            <div className="border-t border-gray-800 py-6">
                <div className="container mx-auto px-4">
                    <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">

                        {/* Copyright */}
                        <div className="text-gray-400 text-sm text-center md:text-left">
                            <p>
                                © {currentYear} Union Démocratique des Bâtisseurs (UDB). Tous droits réservés.
                            </p>
                            <p className="flex items-center justify-center md:justify-start space-x-1 mt-1">
                                <span>Fait avec</span>
                                <Heart className="w-4 h-4 text-red-500" />
                                <span>pour le Gabon</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Back to Top Button avec vraies couleurs UDB */}
            <button
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className="fixed bottom-8 right-8 w-12 h-12 text-white rounded-full shadow-lg transition-all hover:scale-110 flex items-center justify-center z-40"
                style={{backgroundColor: '#00469b'}}
                onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#009026';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#00469b';
                }}
                aria-label="Retour en haut"
            >
                <ChevronRight className="w-5 h-5 transform rotate-[-90deg]" />
            </button>
        </footer>
    );
};

export default Footer;
